import { createContext } from 'react';

import {
  ApiConnection,
  ApiConnectionStatus,
  ApiConnectionSummary,
  ApiConnectionTypeField,
} from '@totem/components/administration/apiConnections/types';

interface Context {
  loading: boolean;
  data: ApiConnectionSummary[];
  typeFields: ApiConnectionTypeField[];
  editingConnection: ApiConnection | null;
  editLoading: boolean;
  modalOpen: boolean;
  onRefresh: () => void;
  onAdd: () => void;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
  onStatusChange: (id: string, status: ApiConnectionStatus) => void;
  onSave: (connection: Partial<ApiConnection>) => void;
  onModalClose: () => void;
}

export default createContext<Context>({
  loading: false,
  data: [],
  typeFields: [],
  editingConnection: null,
  editLoading: false,
  modalOpen: false,
  onRefresh: () => {},
  onAdd: () => {},
  onEdit: () => {},
  onDelete: () => {},
  onStatusChange: () => {},
  onSave: () => {},
  onModalClose: () => {},
});
